import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import { GET_CAMPAIGN_EFFECTS, GET_CAMPAIGN_EFFECTS_SUCCESS, GET_CAMPAIGN_EFFECTS_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';

function* getCampaignEffects({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { campaignId } = payload?.urlParams || {};

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/surge-campaigns/${campaignId}/effects`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_CAMPAIGN_EFFECTS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_CAMPAIGN_EFFECTS_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_CAMPAIGN_EFFECTS_ERROR, payload: error });
  }
}

export function* watchgetCampaignEffects() {
  yield takeEvery(GET_CAMPAIGN_EFFECTS, getCampaignEffects);
}

function* getCampaignEffectsSaga() {
  yield all([fork(watchgetCampaignEffects)]);
}

export default getCampaignEffectsSaga;
